export default __webpack_public_path__ + "static/media/doodleap.3e14ede2.gif";